var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{ref:"menu-modal",attrs:{"id":"menu-modal","title":"Tạo thực đơn mới","hide-footer":"","centered":""},on:{"hidden":_vm.cancel}},[_c('b-overlay',{attrs:{"show":_vm.loading}},[_c('div',[_c('from-menu',{attrs:{"type":_vm.type,"data":_vm.detail},on:{"cancel":_vm.cancel,"submit":_vm.submit}})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }